<template>
  <div
    class="form-field"
    :class="{ 'cursor-not-allowed': disable }"
    @click.stop="$emit('click')"
  >
    <div
      class="row items-center q-col-gutter-md"
      :class="{ 'no-pointer-events': disable }"
    >
      <div
        v-for="option in options"
        :key="option.id"
        :class="optionsSizes[optionsPerLine]"
      >
        <q-radio
          v-model="model"
          size="xs"
          color="secondary"
          :val="option.value"
          class="full-width"
        >
          <div
            class="q-ml-xs text-caption text-capitalize ellipsis"
            :class="[
              model === option.value
                ? 'text-dark text-weight-medium'
                : 'text-grey',
            ]"
          >
            {{ option.label }}
          </div>
        </q-radio>
      </div>
    </div>
  </div>
</template>

<script>
import helperFns from "@/mixins/helper-fns";

export default {
  name: "Radio",

  mixins: [helperFns],

  props: {
    value: {
      type: [String, Number, Boolean],
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },

    optionsPerLine: {
      type: Number,
      default: 0,
    },

    disable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      model: "",
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function () {
        this.model = this.value;
      },
    },

    model() {
      this.$emit("input", this.model);
    },
  },
};
</script>

<style lang="scss" scoped></style>
